/* eslint-disable import/prefer-default-export */

import { useCallback, useMemo } from 'react'

import { AssetsView } from '../constants'

import usePersistentState from '~lib/hooks/usePersistentState'

type UsePersistentAssetsViewParams = {
  key: string
  defaultState: AssetsView
}

export function usePersistentAssetsView({ key, defaultState }: UsePersistentAssetsViewParams) {
  const [persistentView, setPersistentView] = usePersistentState<AssetsView>({
    key: `assetsView:${key}`,
    defaultState,
    serialize: (v) => v as AssetsView,
    deserialize: (v) => v as AssetsView,
  })

  const view = useMemo(() => {
    if (Object.values(AssetsView).includes(persistentView)) {
      return persistentView
    }

    return AssetsView.LIST
  }, [persistentView])

  const handleSetView = useCallback(
    (view: AssetsView) => {
      if (Object.values(AssetsView).includes(view)) {
        setPersistentView(view)
      } else {
        setPersistentView(AssetsView.LIST)
      }
    },
    [setPersistentView]
  )

  return [view, handleSetView] as const
}
